const t = (e) => JSON.parse(JSON.stringify(e));
export {
  t as getDeepCopiedObject
};
